// Modified by AI on 06/09/2026. Edit #1.
import {
    primaryBoxShadow,
    inputColors,
} from './material-kit-pro-react';
import { white, silverChalice, mineShaft } from '../../constants/Colors';

const customSelectStyle = (theme) => ({
    root: {
        border: `1px solid ${inputColors.default.borderColor}`,
        borderRadius: '3px',
    },
    noBorder: {
        border: 'none',
    },
    select: {
        padding: '12px 0 9px',
        fontSize: '15px',
        fontWeight: '300',
        height: '20px',
        textDecoration: 'none',
        paddingLeft: '50px',
        letterSpacing: '0',
        '&:focus': {
            backgroundColor: 'transparent',
        },
        '&[aria-owns] + input + svg': {
            transform: 'rotate(180deg)',
        },
        '& + input + svg': {
            right: '10px',
            transition: 'all 300ms linear',
        },
    },
    selectFormControl: {
        '& > div': {
            marginTop: '0',
            '&:before': {
                borderBottom: `1px solid ${inputColors.default.borderColor} !important`,
                borderRadius: '3px',
            },
            '&:after': {
                height: '96%',
                transition: 'none',
                border: `1px solid ${inputColors.active.borderColor}`,
                borderRadius: '3px',
            },
        },
    },
    selectFormControlNoBorder: {
        '& > div': {
            marginTop: '0',
            '&:before': {
                content: 'none',
            },
        },
    },
    selectFormControlError: {
        '& > div': {
            '&:after': {
                border: `1px solid ${inputColors.error.borderColor} !important`,
                transform: 'scale(1)',
                borderRadius: '3px',
            },
        },
    },
    selectLabel: {
        top: '15px',
        paddingLeft: '10px',
        color: `${silverChalice} !important`,
        fontWeight: '300',
        fontSize: '15px',
    },
    selectLabelShrink: {
        fontSize: '20px',
    },
    selectMenu: {
        '& > div > ul': {
            border: '0',
            padding: '5px 0',
            margin: '0',
            boxShadow: 'none',
            minWidth: '100%',
            borderRadius: '4px',
            boxSizing: 'border-box',
            display: 'block',
            fontSize: '14px',
            textAlign: 'left',
            listStyle: 'none',
            backgroundColor: white,
            backgroundClip: 'padding-box',
        },
        '& $selectPaper $selectMenuItemSelectedMultiple': {
            backgroundColor: 'inherit',
        },
    },
    selectMenuItem: {
        fontSize: '16px',
        padding: '10px 20px',
        transition: 'all 150ms linear',
        display: 'block',
        clear: 'both',
        whiteSpace: 'nowrap',
        color: theme?.common?.text?.color || mineShaft,
        paddingRight: '30px',
        fontWeight: 400,
        lineHeight: '24px',
        letterSpacing: '0.0025em',
        fontFamily: 'Source Sans Pro',
        '&:hover, &.selected': {
            backgroundColor: inputColors.active.borderColor,
            color: white,
        },
    },
    selectMenuItemSelected: {
        backgroundColor: `${inputColors.active.borderColor} !important`,
        color: white,
    },
    selectMenuItemSelectedMultiple: {
        '&:hover': {
            backgroundColor: `${inputColors.active.borderColor}!important`,
            color: white,
            ...primaryBoxShadow,
            '&:after': {
                color: white,
            },
        },
        '&:after': {
            top: '16px',
            right: '12px',
            width: '12px',
            height: '5px',
            borderLeft: '2px solid currentColor',
            transform: 'rotate(-45deg)',
            opacity: '1',
            color: inputColors.active.borderColor,
            position: 'absolute',
            content: '""',
            borderBottom: '2px solid currentColor',
            transition: 'opacity 90ms cubic-bezier(0,0,.2,.1)',
        },
    },
    selectPaper: {
        boxSizing: 'borderBox',
        borderRadius: '4px',
        padding: '0',
        minWidth: '100%',
        display: 'block',
        border: '0',
        boxShadow: '0 2px 5px 0 rgba(0, 0, 0, 0.26)',
        backgroundClip: 'padding-box',
        margin: '2px 0 0',
        fontSize: '14px',
        textAlign: 'left',
        listStyle: 'none',
        backgroundColor: 'transparent',
        maxHeight: '266px',
    },
    withoutLabel: {
        paddingLeft: '10px',
    },
    disabled: {},
    paper: {},
});

export default customSelectStyle;
